<div class="container">
  <div>
    <ion-row>
      <ion-col size="12" size-md="5" push-md="7" class="text-right mt-10">
        <ion-row class="phi-justify-content-center">
	        <ion-col size="12" size-md="2" push-md="10" class="mb-10">
          <span class="close_bg cp" [mat-dialog-close]>
            <img src="././assets/icon/close_icon.png" class="closeHeight">
          </span>
          </ion-col>
	        
          <ion-col size="12" size-md="10" pull-md="2" class="phi-align-content-center phi-justify-content-end mb-10">
        <div class="center-content justify-content-flex-end">

          <div class="center-content justify-content-flex-end" *ngIf="tab=='Resigned Emp'" >
            <label class="mr-10" >Withdrawal</label>
            <mat-slide-toggle class="mr-10" [(ngModel)]="isToggleOn" (change)="onChangeSwitch($event)"></mat-slide-toggle>
            <label class="mr-10" >Resigned</label>
          
          
          </div>
          <div class="center-content justify-content-flex-end" *ngIf="tab=='Regrettable Emp'" >
            <label class="mr-10" >Non-Regret</label>
            <mat-slide-toggle class="mr-10" [(ngModel)]="isToggleOn" (change)="onChangeSwitch($event)"></mat-slide-toggle>
            <label class="mr-10" >Regret</label>
          
          
          </div>
          <div class="center-content justify-content-flex-end" *ngIf="tab=='Resignation Accepted Emp'" >
            <label class="mr-10" >Rejected</label>
            <mat-slide-toggle class="mr-10" [(ngModel)]="isToggleOn" (change)="onChangeSwitch($event)"></mat-slide-toggle>
            <label class="mr-10" >Accepted</label>
          
          
          </div>
          <div class="center-content justify-content-flex-end" *ngIf="tab=='Terminated Emp'" >
            <label class="mr-10" >Revoke</label>
            <mat-slide-toggle class="mr-10" [(ngModel)]="isToggleOn" (change)="onChangeSwitch($event)"></mat-slide-toggle>
            <label class="mr-10" >Terminated</label>
          
          
          </div>
          
        </div>
          </ion-col>
      </ion-row>
      </ion-col>

      <ion-col size="12" size-md="7" pull-md="5" class="phi-align-content-center">
        <!-- <div class="formLabelSemiBoldfs16 mb-5">{{ data.operation === 'Add' ? 'Add' : 'Edit' }} Reimbursement</div> -->
        <div class="formLabelSemiBoldfs16 mb-5" style="margin: 10px;">{{tab}} </div>
      </ion-col>
    </ion-row>
  </div>
  <div class="cardBox mb-20 p-10" >


    <ion-row>
      <ion-col size>
        <mat-form-field class="mat-height40 mat-input-style">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
        </mat-form-field>
      </ion-col>
      <ion-col size="auto">
        <div class="phi-flex-wrap-center phi-gap-12">
        <label class="phi-flex phi-gap-6 phi-align-items-center">
          <ion-label class="fs-14 fs_12ForMobile font_regular black_color">Show</ion-label>
          <mat-form-field class="w70px mat-height40 mat-input-style">
            <mat-select placeholder="Select" placeholder="Select" (selectionChange)="DislaySelectedRecord($event)"  [value]="25">
              <mat-option [value]="2">2</mat-option>
              <mat-option [value]="25">25</mat-option>
              <mat-option [value]="50">50</mat-option>
              <mat-option [value]="75">75</mat-option>
              <mat-option [value]="100">100</mat-option>
            </mat-select>
          </mat-form-field>
          <ion-label class="fs-14 fs_12ForMobile font_regular black_color">entries</ion-label>
        </label>

        <div>
          <div (click)="downloadExitList()" *ngIf="tab !=='Terminated Emp'">
            <span class="ml-5 mr-5 icon-download fs-20 material-icons">download</span>
          </div>
          <div (click)="downloadTerminateList()" *ngIf="tab =='Terminated Emp'">
            <span class="ml-5 mr-5 icon-download fs-20 material-icons">download</span>
          </div>
          </div>
        </div>
      </ion-col>
    </ion-row>


    
    <div *ngIf="tab !=='Terminated Emp'" >
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="table-container">
            <table>
         
              <thead>
                <tr>

                  <th *ngFor="let item of ExitTableHeader" class="fs-14 fs_12ForMobile font_bold cl-black">
                    <div class="p-5 verticle-center justify-content-space-between icon-style" style="width: 90px;">
                      {{ item?.label }}

                    </div>
                  </th>
            
                </tr>
                <tr *ngFor="let item of listofData ">
                  <td>{{ item.empCode }}</td>
                  <td>{{ item.empName }}</td>
                  <td>{{ item.managerFullName }}</td>
                  <td>{{ item.hodFullName }}</td>
                  <td>{{ item.empDepartment }}</td>
                  <td>{{ item.empBand }}</td>
                  <td>{{ item.empGrade }}</td>
                  <td>{{ item.empDesignation }}</td>
                  <td>{{ item.resignDate }}</td>
                  <td>{{ item.employmentType }}</td>
                  <td>{{ item.noticePeriod }}</td>
                  <td>{{ item.lastWorkingDay  }}</td>
                </tr>
                
              </thead>
        
              <tbody>
              
              </tbody>
            </table>
          </div>
        </ion-col>
      </ion-row>
    </div>

    <div class="p-10" *ngIf="tab=='Terminated Emp'" >
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="table-container">
            <table>
         
              <thead>
                <tr>

                  <th *ngFor="let item of terminateTableHeader" class="fs-14 fs_12ForMobile font_bold cl-black">
                    <div class="p-5 verticle-center justify-content-space-between icon-style" style="width: 90px;">
                      {{ item?.label }}

                    </div>
                  </th>
                
                </tr>
                <tr *ngFor="let item of listofData ">
                  <td>{{ item.empCode }}</td>
                  <td>{{ item.empName }}</td>
                  <td>{{ item.empDepartment }}</td>
                  <td>{{ item.empBand }}</td>
                  <td>{{ item.empDesignation }}</td>
                  <td>{{ item.dateOfTermination }}</td>
                  <td>{{ item.lastWorkingDay | date: 'dd/MM/yyyy' }}</td>
                </tr>
                
              </thead>
        
              <tbody>
              
              </tbody>
            </table>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>